import React, { useState, useEffect } from "react"
import "./CookieConsent.css"

const STORAGE_KEY = "cookie_consent"

const updateGtagConsent = (granted) => {
  if (typeof window === "undefined" || !window.gtag) return
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: "denied",
  })
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (!saved) {
      setVisible(true)
    } else {
      updateGtagConsent(saved === "all")
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "all")
    updateGtagConsent(true)
    setVisible(false)
  }

  const handleEssential = () => {
    localStorage.setItem(STORAGE_KEY, "essential")
    updateGtagConsent(false)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-label="Preferencias de cookies"
    >
      <p className="cookie-consent__text">
        Usamos cookies para mejorar tu experiencia y analizar el tráfico.{" "}
        <a href="/privacy-policy">Política de privacidad</a>
      </p>
      <div className="cookie-consent__actions">
        <button
          className="cookie-consent__btn cookie-consent__btn--accept"
          onClick={handleAccept}
        >
          Aceptar todo
        </button>
        <button
          className="cookie-consent__btn cookie-consent__btn--essential"
          onClick={handleEssential}
        >
          Solo esenciales
        </button>
      </div>
    </div>
  )
}

export default CookieConsent
